import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getAllHealth = () => {
  return progressApi.get(`/Health/GetAll${extractedPath}`);
};

export const refreshHealth = (id: any) => {
  return progressApi.get(`/Health/Get${extractedPath}` + `?type=${id}`);
};
